module.exports = __webpack_public_path__ + "images/tips/info-image-04@2x.1fc86945d4000718751e.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/info-image-04@2x.png
// module id = 78tn
// module chunks = 13